import selectUndoSendOption from '../data/mutators/selectUndoSendOption';
import getUndoSendTimeInterval from '../selectors/getUndoSendTimeInterval';
import { observer } from 'mobx-react';
import { Slider } from 'office-ui-fabric-react/lib/Slider';
import { OptionDescription } from 'owa-options-controls';
import { format } from 'owa-strings';
import mailStrings from 'owa-strings/owa-mail-strings';
import optionsStrings from 'owa-strings/owa-options-strings';
import * as React from 'react';

let styles = require('./UndoSendFull.scss');

export default observer(function UndoSendFull() {
    return (
        <div>
            <OptionDescription>
                {' '}
                {format(
                    optionsStrings.options_mail_undoSend_description,
                    mailStrings.composeSendButton,
                    mailStrings.undoAction
                )}{' '}
            </OptionDescription>
            <Slider
                className={styles.undoSendSlider}
                label={optionsStrings.options_mail_undoSend_sliderLabel}
                min={0}
                max={10}
                step={5}
                defaultValue={getInitialValue()}
                showValue={true}
                // tslint:disable-next-line:jsx-no-lambda
                onChange={(value: number) => selectUndoSendOption(value)}
            />
        </div>
    );
});

const getInitialValue = () => {
    let initialValue = getUndoSendTimeInterval();
    return initialValue < 0 ? 0 : initialValue;
};
